import styled from 'styled-components/macro';
import { CSSObject } from 'styled-components';

import {
  AlignItemsType,
  FlexBasisType,
  FlexDirectionType,
  FlexGrowShrinkType,
  FlexWrapType,
  JustifyContentType,
} from 'common/types/flex';

export const FlexBreak = styled.div`
  flex-basis: 100%;
`;

export const Flex = styled.div<{
  flex?: string | number;
  flexBasis?: FlexBasisType;
  flexDirection?: FlexDirectionType;
  flexGrow?: FlexGrowShrinkType;
  flexShrink?: FlexGrowShrinkType;
  flexWrap?: FlexWrapType;
  gap?: string;
  alignItems?: AlignItemsType;
  justifyContent?: JustifyContentType;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  height?: string;
  margin?: string;
  padding?: string;
  border?: string;
  borderLeft?: string;
  borderBottom?: string;
  borderTop?: string;
  borderRadius?: string;
  whiteSpace?: string;
  hideOnMobile?: boolean;
  backgroundColor?: string;
  isSticky?: boolean;
  cursor?: string;
  boxShadow?: string;
  overflow?: string;
  cssStyle?: CSSObject;
}>`
  display: flex;
  flex: ${({ flex }) => flex || '0 1 auto'};
  flex-basis: ${({ flexBasis }) => flexBasis || 'auto'};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  flex-grow: ${({ flexGrow }) => flexGrow || 0};
  flex-shrink: ${({ flexShrink }) => flexShrink ?? 1};
  flex-wrap: ${({ flexWrap }) => flexWrap || 'nowrap'};
  gap: ${({ gap }) => gap || '0'};
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  cursor: ${({ cursor }) => cursor || 'auto'};

  width: ${({ width }) => width || 'auto'};
  min-width: ${({ minWidth }) => minWidth || 'none'};
  max-width: ${({ maxWidth }) => maxWidth || 'none'};
  height: ${({ height }) => height || 'auto'};
  margin: ${({ margin }) => margin || '0'};
  padding: ${({ padding }) => padding || '0'};
  border: ${({ border }) => border || 'none'};
  ${({ borderLeft }) => borderLeft && `border-left: ${borderLeft}; padding: 0 0 0 1.5rem;`};
  ${({ borderBottom }) => borderBottom && `border-bottom: ${borderBottom};`};
  ${({ borderTop }) => borderTop && `border-top: ${borderTop};`};
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius}`};
  background-color: ${({ backgroundColor }) => backgroundColor && backgroundColor};

  ${({ whiteSpace }) => whiteSpace && `  white-space: ${whiteSpace}; `}
  ${({ boxShadow }) => boxShadow && `  box-shadow: ${boxShadow}; `}
  ${({ overflow }) => overflow && `  overflow: ${overflow}; `}

  ${({ cssStyle }) => cssStyle && cssStyle};

  ${({ isSticky, theme, backgroundColor }) =>
    isSticky &&
    `   position: sticky;
        bottom: 0;
        background-color: ${backgroundColor ? backgroundColor : theme.colors.white};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
  }
`;
